import { createFileRoute } from '@tanstack/react-router'
import { DoctorSignaturePage } from '@/features/users/signature'

export const Route = createFileRoute('/users_/$userId/signature')({
  component: RouteComponent,
})

function RouteComponent() {
  const { userId } = Route.useParams()
  return <DoctorSignaturePage userId={userId} />
}
